import { SubRetailerService } from '@/services/retailer/SubRetailerService'
import { build_query, errorMessage } from '@/utilities/helpers.js'

import { RETAILER_ERROR_MESSAGES } from '@/constants/errorMessages'

export const namespaced = true

export const allowedFiltersForStatistics = ['by_retailer_user']
export const allowedFiltersForOrders = ['by_retailer_user']
export const allowedIncludesForOrders = 'farmer'
export const allowedSortsForOrders = '-created_at'

export const state = {
  retailers: [],
  users: [],
  orders: [],
  ordersMeta: null,
  retailer: null,
  statistics: {}
}

export const mutations = {
  SET_RETAILERS(state, retailers) {
    state.retailers = retailers
  },
  SET_RETAILER(state, retailer) {
    state.retailer = retailer
    state.users = retailer.users
  },
  SET_STATISTICS(state, statistics) {
    state.statistics = statistics
  },
  SET_ORDERS(state, orders) {
    state.orders = orders.data
    state.ordersMeta = orders.meta
  }
}

export const getters = {
  getRetailerUserById: state => id => {
    return state.retailer.users ? state.retailer.users.find(user => user.id === id) : false
  }
}

export const actions = {
  getRetailers({ commit, dispatch }, query) {
    return new Promise((resolve, reject) => {
      SubRetailerService.getRetailers(query)
        .then(response => {
          commit('SET_RETAILERS', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: RETAILER_ERROR_MESSAGES.getSubRetailersError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getRetailer({ commit, dispatch }, retailerId) {
    return new Promise((resolve, reject) => {
      SubRetailerService.getRetailer(retailerId)
        .then(response => {
          commit('SET_RETAILER', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: RETAILER_ERROR_MESSAGES.getSubRetailerError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getStatistics({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      let newQuery = build_query(params.query, allowedFiltersForStatistics)

      SubRetailerService.getStatistics(params.retailer_id, newQuery)
        .then(response => {
          commit('SET_STATISTICS', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: RETAILER_ERROR_MESSAGES.getSubRetailerStatisticsError + errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  getOrders({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      let newQuery = build_query(params.query, allowedFiltersForOrders, allowedIncludesForOrders, allowedSortsForOrders)

      SubRetailerService.getOrders(params.retailer_id, newQuery)
        .then(response => {
          commit('SET_ORDERS', response)
          resolve(response)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: RETAILER_ERROR_MESSAGES.getSubRetailerOrdersError + errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  }
}
